import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/orders/managing-payments-for-orders/global'

export const MANAGING_PAYMENTS_FOR_ORDERS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
